import { request } from '../utils/request'
import { querystring } from '../utils/index'
export default {
  deletescantag: option => request('v1/scantag/deletescantag' + querystring(option), option), //  删除扫码记录
  changedeliverytype: option => request('v1/outstock/changedeliverytype' + querystring(option), option) //  修改发货对象
}
